import { Component } from '@angular/core';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { DialogService } from 'primeng/dynamicdialog';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { firstValueFrom } from 'rxjs';
import { ProductsService } from '../_services/products.service';
import { Product } from '../_types/product';
import { ProductsDetailComponent } from '../products-detail/products-detail.component';
import { FilterFieldConfig } from 'src/app/core/filter-panel/filter-field.model';
import { LoginService } from '../../login/login.service';

@Component({
    selector: 'app-products-list',
    templateUrl: './products-list.component.html',
    styleUrls: ['./products-list.component.scss'],
    host: { class: 'list-page' },
    standalone: false
})
export class ProductsListComponent {

  public products: Product[] = [];

  public totalRecords: number = 0;
  public loading: boolean = false;
  private lastGridEvent: any;
  public filters: any = {
    module: new Filter(FilterOperation.equals, 'module'),
    name: new Filter(FilterOperation.contains, 'name'),
  };

  public moduleOptions: { label: string; value: any }[] = [];
  public fieldsConfig: FilterFieldConfig[] = [
    { filter: this.filters.module, type: 'select', label: 'Módulo', options: this.moduleOptions, filterable: true, base: true },
    { filter: this.filters.name, type: 'text', label: 'Nombre', base: true }
  ];
  public modules: string[] = [];
  public allowWrite: boolean = false;

  constructor(
    public productsService: ProductsService,
    private topbarService: TopbarService,
    private dialogService: DialogService,
    private loginService: LoginService
  ) {

  }

  ngOnInit(): void {
    this.topbarService.setTitle("Precios");
    this.allowWrite = this.loginService.hasPermission("PRODUCTS.WRITE");
    this.loadModules();
  }

  private async loadModules() {
    this.modules = await firstValueFrom(this.productsService.getModules());
    this.moduleOptions.length = 0;
    this.moduleOptions.push(...this.modules.map(m => ({ label: m, value: m })));
  }

  public async loadData($event: any) {

    this.lastGridEvent = $event;

    let params: IParamsCollection = {
      page: { number: $event.first, size: $event.rows }
    }

    if (typeof $event.sortField != "undefined") params.sort = [($event.sortOrder > 0 ? "" : "-") + $event.sortField];

    //creamos filtros
    params.filter = FilterBuilder.fromObject(this.filters).build();

    let response = await firstValueFrom(this.productsService.all(params));
    this.products = response.data;
    this.totalRecords = response.meta['total'];
    this.topbarService.setCount(this.totalRecords);
  }

  clearFilters() {
    this.filters = {};
    this.search();
  }

  search() {
    this.lastGridEvent.first = 0;
    this.loadData(this.lastGridEvent);
  }

  edit(product: any) {
    const ref = this.dialogService.open(ProductsDetailComponent, {
      closable: true,
      modal: true,
      data: {
        id: product.id
      },
      header: "Modificar el precio",
      width: '40%'
    });
    ref.onClose.subscribe(() => {
      this.loadData(this.lastGridEvent);
    });
  }

}
